import { FormPanel } from "../../../../modules/content/components/FormPanel/FormPanel";
import { WohaCommonContent } from "../../../../modules/content/components/WohaCommonContent/WohaCommonContent";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { IFormBlockProps } from "./FormBlock.props";

export const FormBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  errorMessage,
  eyebrow,
  fields,
  heading,
  parentClass,
  spacing,
  submitLabel,
  successMessage,
}: IFormBlockProps) => {
  if (!fields?.length) return null;

  return (
    <WohaSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="mx-auto flex max-w-3xl flex-col gap-10 md:gap-12">
        <WohaCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <FormPanel
          errorMessage={errorMessage}
          fields={fields}
          submitLabel={submitLabel}
          successMessage={successMessage}
        />
      </div>
    </WohaSection>
  );
};

FormBlock.displayName = "Block::FormBlock";
